import React, { useContext, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextInfoContent from '@mui-treasury/components/content/textInfo';
import { useBlogTextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/blog';
import { useOverShadowStyles } from '@mui-treasury/styles/shadow/over';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import cx from 'clsx';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { useFullBorderedGridStyles } from '@mui-treasury/styles/grid/fullBordered';

import { getAchievementBadgesByStudentNumber } from '../../actions/profile-actions';
import ProfileContext from '../../context/profile-context';
import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'


const useStyles = makeStyles(({ breakpoints, spacing }) => ({
    root: {
        margin: '10px',
        borderRadius: spacing(2), // 16px
        transition: '0.3s',
        boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
        position: 'relative',
        maxWidth: 500,
        overflow: 'initial',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [breakpoints.up('md')]: {
            flexDirection: 'row',
            paddingTop: spacing(2),
        },
    },
    logo: {
        display: 'block !important',
        margin: 'auto !important',
        width: 200,
        height: 155,
        boxShadow: '0 4px 12px 0 rgba(0,0,0,0.24)',
        borderRadius: '1rem',
    },
    content: {
        padding: 24,
    },
    cta: {
        marginTop: 24,
        textTransform: 'initial',
    },
}));

export const Badges = React.memo(function SolidGameCard() {

    const { profileContext, dispatch } = useContext(ProfileContext)
    const [badges, setBadges] = useState([])
    const [data, setData] = useState({
        studentNumber: '',
        page: 1,
        size: 4,
    })
    const styles = useStyles();
    const {
        button: buttonStyles,
        ...contentStyles
    } = useBlogTextInfoContentStyles();
    const shadowStyles = useOverShadowStyles();
    const customGrid = useFullBorderedGridStyles({ borderColor: '#fff' });
    const colWidth = { xs: 12, sm: 6, md: 4, lg: 3 };
    const [open, setOpen] = React.useState(false);
    const [badge, setBadge] = React.useState({ badgeName: '', evidence: '', issuedOn: '', badgeImage: '' });

    const handleClickOpen = (item) => {
        setBadge({
            badgeName: item.badgeName,
            evidence: item.evidence,
            issuedOn: ConvertDateString.convertForDatePicker(item.issuedOn),
            badgeImage: item.badgeImage
        })
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const initBadges = async () => {
            const response = await getAchievementBadgesByStudentNumber(data);
            setBadges(response.data)
            response.data = badges.concat(response.data)
            dispatch({ type: 'SET_BADGES', badges: response });
        };
        initBadges()
    }, [data])

    const handleLoadMore = () => {
        if (data.page < profileContext.badges.pageTotal) {
            setData({
                ...data,
                page: data.page + 1
            })
        }
    }

    return (
        <>
            {
                profileContext.badges.totalCount < 1 ?
                    <Typography variant="h6" gutterBottom>
                        Watch out this space for badges.
                    </Typography>
                    :
                    <Grid container classes={customGrid}>
                        {
                            profileContext.badges.data && profileContext.badges.data.map((item, i) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <Grid key={i} item {...colWidth} classes={customGrid}>
                                    <Card className={cx(styles.root, shadowStyles.root)}>
                                        <CardContent>
                                            <div style={{ dispaly: 'block', margin: 'auto' }}>
                                                <Avatar className={styles.logo} src={item.badgeImage} />
                                            </div>
                                            <TextInfoContent
                                                classes={contentStyles}
                                                heading={item.badgeName}
                                                body={
                                                    item.badgeDescription
                                                }
                                            />
                                            <Button onClick={() => handleClickOpen(item)} className={buttonStyles}>See more</Button>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        {
                            data.page < profileContext.badges.pageTotal &&
                            <div style={{ dispaly: 'block', margin: 'auto' }}>
                                <Button onClick={handleLoadMore} className={buttonStyles}>Load More </Button>
                            </div>
                        }
                    </Grid>
            }

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Issued On {badge.issuedOn}</DialogTitle>
                <DialogContent>
                    <div style={{ dispaly: 'block', margin: 'auto' }}>
                        <Avatar className={styles.logo} src={badge.badgeImage} />
                    </div>
                    <DialogContentText style={{ marginTop: 15 }}>
                        <Typography variant="body1" display="block">
                            This badge is awarded to you because <span style={{ color: 'orangered' }}>{badge.evidence}</span>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className={buttonStyles}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
});

export default Badges;
